module.exports = ".errorInput {\r\n    border: 1px solid #dd2d2d;\r\n}\r\nlabel{\r\n    padding-top: 20px\r\n}\r\n.col-md-5{\r\n    padding-top: 0px\r\n}"